import { HTMLAttributes } from "react";

export const LogoViewBoxIcon = ({
  id,
  className,
  style,
}: StyledProps & Pick<HTMLAttributes<SVGAElement>, "id">) => {
  return (
    <svg
      id={id}
      className={className}
      style={style}
      transform="scale(1.1)"
      width="69"
      height="33"
      viewBox="0 0 69 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.2854 24.4816V4.08789H28.3516V24.3088C28.3516 26.4815 30.1127 28.2426 32.2854 28.2426H36.0464V24.4816H32.2854Z"
        fill="currentColor"
      />
      <path
        d="M41.6525 24.4816V4.08789H37.7188V24.3088C37.7188 26.4815 39.4799 28.2426 41.6525 28.2426H45.4136V24.4816H41.6525Z"
        fill="currentColor"
      />
      <path
        d="M4 28.243L12.9376 4.08789H17.2295L26.1665 28.243H21.6465L20.0936 23.8605H10.2585L8.77509 28.243H4ZM18.7817 20.0992L15.196 9.38856L11.5704 20.0992H18.7821H18.7817Z"
        fill="currentColor"
      />
      <path
        d="M46.5703 20.168L46.777 20.0298L50.4347 19.6849C50.6766 22.7214 52.5744 24.9299 55.8177 24.9299C58.6821 24.9299 60.5802 23.0664 60.5802 19.8573C60.5802 16.5446 57.9919 14.8884 55.0241 14.8884H54.0235V11.6102L58.3368 7.67644H47.5709V4.08789H63.5131V7.64219L58.4751 11.99C61.6847 12.7836 64.7556 15.1645 64.7556 19.8231C64.7556 24.8269 60.9254 28.5879 55.818 28.5879C50.1937 28.5879 46.8461 24.792 46.5703 20.1683V20.168Z"
        fill="currentColor"
      />
    </svg>
  );
};
